<template>
  <v-row>
    <v-col v-if="loading" cols="12">
      <v-progress-linear indeterminate color="green" />
    </v-col>
    <v-col v-for="migration in migrationsFormatted" :key="`mi-${migration.id}`" cols="12">
      <migrations-list-item :migration="migration" />
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import { migrationStatusColor } from 'Helpers/helpers'
import MigrationsListItem from './MigrationsListItem'

export default {
  name: 'MigrationsList',
  components: {
    MigrationsListItem
  },
  computed: {
    ...mapGetters({
      loading: 'migrations/loadingMigrations',
      migrations: 'migrations/migrations',
    }),
    migrationsFormatted () {
      return this.migrations.map(migration => {
        return {
          ...migration,
          status_color: this.statusColor(migration.status)
        }
      })
    }
  },
  data () {
    return {
      headers: [
        { text: 'ID Number', sortable: true, value: 'id' },
        { text: 'Service', sortable: false, value: 'service_name' },
        { text: 'Status', true: false, value: 'status' },
        { text: 'Actions', sortable: false, value: 'actions', align: 'center' },
      ]
    }
  },
  methods: {
    statusColor: migrationStatusColor
  }
}
</script>
